<div class="modal-content-wrapper">
    <header class="modal-header">
        <h1 class="modal-title">{{"copy.html.Login-Decline.title"|copy|async}}</h1>
        <div class="close-container" (click)="onClick('0')">
        <div class="leftright"></div>
        <div class="rightleft"></div>
        </div>
        <!-- <button class="btn btn-outline-light closeButton"  (click)="onNoClick()">X</button> -->
    </header>
    <form name="declineForm" #declineForm="ngForm" class="contactForm" >
        <mat-dialog-content class="modal-body">
            <div class="w-100">
                <p class="w-100">
                    {{"copy.html.Login-Decline.text"|copy|async}}
                </p>
            </div>
        </mat-dialog-content>
        <footer id="modal-footer">
            <div class="button_group d-flex">
                
                <button data-dismiss="modal" (click)="onClick('0')" class="btn btn-outline-light cancelBtn">{{"copy.html.Login-Decline.no"|copy|async}}</button>
                <button cdkfocusinitial (click)="onClick('1')" class="btn btn-outline-light sendBtn">{{"copy.html.Login-Decline.yes"|copy|async}}</button>
            </div>
        </footer>
    </form>
</div>
